import { createTheme } from '@mui/material/styles';
import shippoTheme from '../styles/shippoTheme.js';
import { colors } from '../styles/colors.js';

const cardBoundaryThemeInput = {
    components: {
        MuiContainer: {
            styleOverrides: {
                root: {
                    border: '1px solid',
                    borderRadius: '4px',
                    borderColor: colors.borders,
                },
            },
        },
    },
};
var cardBoundaryTheme = createTheme(shippoTheme, cardBoundaryThemeInput);

export { cardBoundaryThemeInput, cardBoundaryTheme as default };
//# sourceMappingURL=CardBoundary.theme.js.map
